import { render, staticRenderFns } from "./staff_details.vue?vue&type=template&id=7e1c2d58&scoped=true&"
import script from "./staff_details.vue?vue&type=script&lang=js&"
export * from "./staff_details.vue?vue&type=script&lang=js&"
import style0 from "./staff_details.vue?vue&type=style&index=0&id=7e1c2d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1c2d58",
  null
  
)

export default component.exports